export default function totalArray(array) {
  let sum = 0
  array.forEach((num) => {
    sum += parseInt(num)
  })
  return sum
}


// WEBPACK FOOTER //
// ./src/helpers/totalArray.js